import { Product_Info } from "@/globalcfg";
import Masonry from 'masonry-layout';
import pixelArtDialog from "@/Painting/imagegenerate/pixelArtDetails/pixelArtDetails_Dialog.vue";
import { assembleProtocolDV102 } from "@/assembleprotocol/dv102";
export default {
  components: {
    pixelArtDialog,
    Product_Info
  },
  // 增加了 loadend 事件，通知父组件加载完成了
  emits: ["loadend"],
  data() {
    return {
      images: [],
      // 存储图片和信息的数组
      imagesMap: new Map(),
      // 存储图片和信息的Map，方便后续查找和更新信息
      page: 1,
      // 当前页数
      loading: false,
      // 是否正在加载
      finished: false,
      // 是否已加载完所有数据
      imageloadUrl: '/imageprocesshost' + '/showimages',
      //上传图片的接口
      masonryInstance: null,
      // Masonry 实例

      // 加载完成后，留一点空白，给用户一个视觉提示，空白的提示flag
      loadendflag: false,
      // 预置图片相关信息
      isShowDialog: false,
      selectedEffectInfo: {
        smallimg: null,
        id: "",
        likestatus: false,
        unlikestatus: false,
        ldrname: "",
        product_type: "",
        color_numbers: []
      },
      // 选中的像素画信息
      selectedParticleImg: null,
      // 拼装相关参数和数据
      builddata: null
    };
  },
  mounted() {
    this.loadMore(); // 初始加载
    // this.initMasonry(); // 初始化 Masonry 布局
  },

  activated() {
    if (this.masonryInstance) {
      this.masonryInstance.reloadItems();
      this.masonryInstance.layout();
    } else {
      this.initMasonry();
    }
  },
  methods: {
    initMasonry() {
      // 初始化 Masonry 实例
      this.masonryInstance = new Masonry(this.$refs.masonryContainer.querySelector('.show-grid'), {
        itemSelector: '.show-grid-item',
        columnWidth: '.show-grid-sizer',
        percentPosition: true,
        horizontalOrder: true // 是否按水平顺序排列
      });

      this.masonryInstance.layout();
    },
    async loadMore() {
      // 当前如果不是主页路由，则不加载图片

      if (this.$route.name != "Home") {
        return;
      }
      if (this.loading || this.finished) {
        this.$emit('loadend');
        return;
      }
      this.loading = true;
      try {
        let requesturl = this.imageloadUrl + "?page=" + this.page;
        const response = await fetch(requesturl);
        const data = await response.json();

        // 返回的数据格式为：
        // {
        //   "code": 200,
        //   "images": [
        //     {  "assemblename": "xyz.json", 
        //        "imagedata": "xyz_base64", 
        //        "producttype": "littlebrick",
        //        "imagename": "xyz",
        //        "name": "xyz",
        //        "imageid
        //     },
        //    "page_seq": 1,
        //    "total_pages": 5

        if (data && data.code == 200) {
          let images = data.images;
          if (images.length == 0) {
            // 已加载完所有数据
            // 再向上滚动一点距离，给用户一个加载完毕的视觉空间
            this.loadendflag = true;
            this.finished = true;
            this.$emit('loadend');

            // 触发 Masonry 重新布局
            this.$nextTick(() => {
              if (this.masonryInstance) {
                this.masonryInstance.layout();
              }
            });
          } else {
            this.loadMoreImages(data);
          }
        } else {
          this.finished = true;
        }
      } catch (error) {
        console.error('failed to load image:', error);
      } finally {
        this.loading = false;
      }
    },
    // 加载新增的图片
    loadMoreImages(data) {
      // 获取当前 Masonry 实例中的项目数量
      const oldItems = this.masonryInstance ? this.masonryInstance.getItemElements() : [];
      const oldCount = oldItems.length;

      // data数据是从后台拉取的，所以是没有like和unlike的状态的，所以这里需要手动添加
      data.images.forEach(item => {
        item.likestatus = false;
        item.unlikestatus = false;
        this.imagesMap.set(item.name, item);
      });
      this.images = [...this.images, ...data.images];
      this.page += 1;

      // 在 nextTick 中处理 DOM 操作
      this.$nextTick(() => {
        // 获取 Masonry 容器的引用
        const masonryContainer = this.$refs.masonryContainer;
        if (!masonryContainer) {
          return;
        }

        // 如果 Masonry 实例尚未初始化，则初始化
        if (!this.masonryInstance) {
          this.initMasonry();
        } else {
          // 获取所有的 show-grid-item 元素
          const allItems = masonryContainer.querySelectorAll('.show-grid-item');
          // 计算新添加的元素
          const newItems = Array.from(allItems).slice(oldCount);
          if (newItems.length > 0) {
            // 将新元素添加到 Masonry 布局
            this.masonryInstance.appended(newItems);
            this.masonryInstance.layout();
          }
        }
      });
    },
    onImageLoad(event, index) {
      // 当图片加载完成时，触发 Masonry 布局更新
      this.$nextTick(() => {
        this.masonryInstance.layout();
      });
    },
    get_product_name(product_type) {
      // console.log("product_type:", product_type);

      // const lowercaseProductInfo = product_type.toLowerCase();
      // 从 Product_Info 的key中获取产品信息
      let product_info = Product_Info[product_type];

      // 根据语言环境返回产品名称
      if (this.$i18n.locale == "en") {
        return product_info.show_name;
      } else {
        return product_info.show_name_zh;
      }
    },
    // 显示图片信息，使用对话框方式将预置图片信息显示出来
    async onShowDialog(item) {
      // 由于需要获得图片的详细信息，所以需要调用后台接口
      let assembleinfo = item.assemblename;

      // console.log("onshow dialog assembleinfo:", assembleinfo);
      // console.log("onshow dialog item:", item);

      try {
        // 从后台获取图片的详细信息
        let requesturl = this.imageloadUrl + "?assembleinfo=" + assembleinfo;
        const response = await fetch(requesturl);
        const data = await response.json();
        if (data && data.encode == 200 || data.code == 200) {
          let newdata = data;
          if (item.producttype == Product_Info.DiamondPainting.key || item.producttype == Product_Info.DiamondPainting.path) {
            // 钻石画使用的是DV102协议
            newdata = assembleProtocolDV102(data);
          }
          let color_numbers = newdata.data[0].color;
          this.selectedEffectInfo.smallimg = item.imagedata;
          this.selectedEffectInfo.id = item.name;
          this.selectedEffectInfo.product_type = item.producttype;
          this.selectedEffectInfo.color_numbers = color_numbers;
          this.selectedEffectInfo.likestatus = item.likestatus;
          this.selectedEffectInfo.unlikestatus = item.unlikestatus;

          // 这里用path来判断选中的是哪个产品类型
          Object.keys(Product_Info).forEach((key, index) => {
            if (key == item.producttype) {
              this.selectedParticleImg = Product_Info[key].particle_img;
            }
          });

          // 拼装数据
          this.builddata = newdata;
          this.selectedSmallImg = item.imagedata;
          this.isShowDialog = true;
        }
      } catch (error) {
        console.error('获取图片详细信息失败:', error);
      } finally {}
    },
    // 关闭对话框
    onCloseDialog() {
      this.isShowDialog = false;
    },
    onClicklike(imginfo) {
      // this.images.forEach((item) => {
      //   if (item.name == imginfo.id) {
      //     // 切换点赞状态
      //     item.likestatus = imginfo.likestatus;
      //     item.unlikestatus = imginfo.unlikestatus;
      //   }
      // });

      let item = this.imagesMap.get(imginfo.id);
      if (item) {
        item.likestatus = imginfo.likestatus;
        item.unlikestatus = imginfo.unlikestatus;
      }
    }
  }
};